import React from 'react'
import withView from '../../../../cmn/docAutomation/withView';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormInput from '../../../../../library/form/components/FormInput';
import FormLabel from '../../../../../library/form/components/FormLabel';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import FormHHMMInput from '../../../../../library/form/components/FormHHMMInput';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import { UiView, UiViewContent, UiGridColTwo, UiCol } from "../../../../../library/layout/Index";

const ProdTaskActionHeader = (props) => {
    const { formObject } = props;

    return (
        <UiView>
            <UiViewContent>
                <UiGridColTwo>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "processName" }} value="Process Name" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "processName" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profile" }} value="Worker" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'profile' }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "soId" }} value="Service Order" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'soId' }} />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty" }} value="Qty" />
                                </span>
                                <FormInput formObject={formObject} className="uiWidth55" rowKey=""
                                    action={{ InputType: "input", actionId: "refresh", paramName: 'qty1', actionParam: { actionType: "updateTaskActionHeader" } }} />
                                <FormWrapper customWrapper="span" formObject={formObject} rowKey="" action={{ paramName: "uom1" }} >
                                    <SarasTrans value="/" />
                                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'uom1' }} />
                                </FormWrapper>
                                <FormWrapper customWrapper="span" formObject={formObject} rowKey="" action={{ paramName: "qty2" }} >
                                    <FormInput formObject={formObject} className="uiWidth55" rowKey=""
                                        action={{ InputType: "input", actionId: "refresh", paramName: 'qty2', actionParam: { actionType: "updateTaskActionHeader" } }} />
                                    <SarasTrans value="/" />
                                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'uom2' }} />
                                </FormWrapper>
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "issuedDT" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "issuedDT" }} value="Issued On" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'issuedDT' }} />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "issuedOn" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "issuedOn" }} value="Issued On" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal mousetrap"
                                    action={{ InputType: "dp", actionId: "refresh", paramName: "issuedOn", actionParam: { actionType: "updateTaskActionHeader" } }} />
                                <FormHHMMInput formObject={formObject} rowKey="" className="uiTimeInput" 
                                    action={{ actionId: "refresh", InputType: "input", paramName: "issuedOnTime", actionParam: { actionType: "updateTaskActionHeader" } }} />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "returnedDT" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "returnedDT" }} value="Returned On" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: 'returnedDT' }} />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "returnedOn" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "returnedOn" }} value="Returned On" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal mousetrap"
                                    action={{ InputType: "dp", actionId: "refresh", paramName: "returnedOn", actionParam: { actionType: "updateTaskActionHeader" } }} />

                                <FormHHMMInput formObject={formObject} rowKey="" className="uiTimeInput" 
                                    action={{ actionId: "refresh", InputType: "input", paramName: "returnedOnTime", 
                                    actionParam: { actionType: "updateTaskActionHeader" } }} />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskComment" }} value="Comment" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiVal mousetrap"
                                    action={{ InputType: "input", actionId: "refresh", paramName: "taskComment", actionParam: { actionType: "updateTaskActionHeader" } }} />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "saveHeader" }} >
                                <FormButton formObject={formObject} className="uiActionButton"
                                    confirm="Save Qty / Date Changes"
                                    action={{ actionId: "save", 
                                    actionParam: {actionType : "saveQtyDateChanges"} }}
                                    text={<SarasTrans value="Save Changes" />}>
                                </FormButton>
                           </FormWrapper>
                        </ul>
                    </UiCol>
                </UiGridColTwo>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdTaskActionHeader, "prodTaskIssue", "prodTask");
